<script>
import { latLng } from "leaflet"
import { LMap, LTileLayer, LMarker, LIcon } from "@vue-leaflet/vue-leaflet"

export default {
  data() {
    return {
      zoom: 13,
      center: latLng(47.41322, -1.219482),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withTooltip: latLng(47.41422, -1.250482),
      showParagraph: false,
      userLocation: null,
      mapOptions: {
        zoomSnap: 0.5,
      },
      showMap: true,
    }
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
  },
  methods: {
    getUserLocation() {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          console.log(
            position.coords.latitude + "----" + position.coords.longitude
          )

          this.withTooltip = latLng(
            position.coords.latitude,
            position.coords.longitude
          )
          this.center = latLng(
            position.coords.latitude,
            position.coords.longitude
          )
        })
      } else {
        console.error("مکان‌یابی در مرورگر شما پشتیبانی نمی‌شود.")
      }
    },

    handleMapClick(event) {
      console.log(event.latlng.lat + "-------------" + event.latlng.lng)
      this.withTooltip = latLng(event.latlng.lat, event.latlng.lng)
    },
  },
}
</script>

<template>
  <l-map
    :zoom="zoom"
    :center="center"
    :options="mapOptions"
    @click="handleMapClick"
    style="height: 400px; width: 100%"
  >
    <l-tile-layer :url="url" :attribution="attribution" />
    <l-marker :lat-lng="withTooltip">
      <l-icon>
        <img src="@/assets/images/leaflet/marker-icon.png" />
      </l-icon>
    </l-marker>
  </l-map>
  <button @click="getUserLocation">لوکیشن من</button>
</template>
